import { gql } from "@apollo/client";

export default gql`
  query Driver($id: Int!) {
    driver(id: $id) {
      id
      birthday
      cpf
      licenseCategory
      licenseExpirationDate
      licenseNumber
      name
      officialDocument
      country {
        code
      }
    }
  }
`;
